var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7761 3.57376C14.2748 2.80875 9.68118 2.80875 5.17992 3.57376C2.60599 4.12505 1 5.82364 1 8.04001V15.9149C1 18.1649 2.60599 19.8412 5.22414 20.4148L5.22396 20.415C7.46308 20.8005 9.72946 20.9962 11.9999 21C14.2775 20.9994 16.5511 20.8075 18.798 20.4262C21.35 19.9312 23 18.1761 23 15.9262V8.05134C23 5.81255 21.35 4.05745 18.776 3.57381L18.7761 3.57376ZM15.586 12.5065L10.0858 15.8815C9.99976 15.9351 9.9005 15.9625 9.79977 15.9602C9.70438 15.9594 9.61028 15.9363 9.52483 15.8928C9.34878 15.7833 9.24363 15.5858 9.24989 15.3752V8.62521C9.25155 8.42256 9.3556 8.23535 9.52483 8.13024C9.69996 8.03419 9.91063 8.03419 10.0857 8.13024L15.586 11.5053C15.7475 11.6105 15.8453 11.793 15.8453 11.9889C15.8453 12.1849 15.7475 12.3673 15.586 12.4727L15.586 12.5065Z",
    fill: "#697077"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.24985eb2.svg";
export { ForwardRef as ReactComponent };